module.exports = __webpack_public_path__ + "static/media/Button_This_Week.5c1b645e.png";